(function() {
    var loadedFontFamilies = {};
    var HIDDEN = ".key_option_condition_hidden, .key_option_hidden, .key_option_oos_hidden, .key_option_value_oos_hidden";

    function isHidden(el) {
        return !el || !!el.closest(HIDDEN);
    }

    function lastInRange(startEl, endEl, selector) {
        var nodes = document.querySelectorAll(selector);
        var found = null;
        var i;
        for (i = 0; i < nodes.length; i++) {
            if (isHidden(nodes[i])) continue;
            if (endEl && endEl.contains(nodes[i])) continue;
            if (startEl) {
                if (!(startEl.compareDocumentPosition(nodes[i]) & Node.DOCUMENT_POSITION_FOLLOWING)) continue;
            }
            if (endEl) {
                if (!(endEl.compareDocumentPosition(nodes[i]) & Node.DOCUMENT_POSITION_PRECEDING)) continue;
            }
            found = nodes[i];
        }
        return found;
    }

    function isPreviewTitle(title) {
        var text = title.textContent.replace(/\s+/g, " ").trim().toLowerCase();
        return text === "preview" || text.indexOf("preview") === 0;
    }

    function findAllPreviewHosts() {
        var hosts = [];
        var seen = [];

        function addHost(el) {
            if (!el || isHidden(el)) return;
            if (el.getAttribute && el.getAttribute("data-kp-extra") === "true") return;
            var wrap = el.closest(".key_option_wrapper") || el;
            if (seen.indexOf(wrap) !== -1) return;
            seen.push(wrap);
            hosts.push(wrap);
        }

        var nodes = document.querySelectorAll(".key_option_wrapper.custom_preview");
        var i;
        for (i = 0; i < nodes.length; i++) addHost(nodes[i]);

        var titles = document.querySelectorAll(".key_option_title");
        for (i = 0; i < titles.length; i++) {
            if (isPreviewTitle(titles[i])) addHost(titles[i]);
        }

        return hosts;
    }

    function getPreviewBoxForHost(host) {
        if (!host) return null;

        var box = host.querySelector(".js-custom-preview-box");
        if (box) return box;

        if (host.id === "custom_preview" || host.classList.contains("js-custom-preview-box")) {
            return host;
        }

        if (host.classList.contains("custom_preview") && !host.classList.contains("key_option_wrapper")) {
            return host;
        }

        var inner = host.querySelector(".custom_preview:not(.key_option_wrapper), .key_display_text_content, .key_option_element") || host;
        box = inner.querySelector(".js-custom-preview-box");
        if (box) return box;
        if (inner.classList.contains("js-custom-preview-box") || (inner.classList.contains("custom_preview") && inner !== host)) {
            return inner;
        }

        box = document.createElement("div");
        box.className = "custom_preview js-custom-preview-box";
        inner.appendChild(box);
        return box;
    }

    function isIgnoredInput(el) {
        if (!el) return true;
        if (el.classList.contains("key_color_text")) return true;
        if (el.classList.contains("key_color_dropdown_input")) return true;
        if (el.classList.contains("key_font_dropdown_input")) return true;
        if (el.classList.contains("key_combobox_input")) return true;
        if (el.getAttribute("role") === "combobox") return true;
        return false;
    }

    function getAllTextInputs() {
        var selectors = [
            ".key_option_tb input",
            ".key_option_tb_render input",
            "[data-option-type='textbox'] input",
            "[data-option-type='textarea'] textarea",
            ".key_option_ta textarea"
        ];
        var seen = [];
        var s;
        var i;
        for (s = 0; s < selectors.length; s++) {
            var nodes = document.querySelectorAll(selectors[s]);
            for (i = 0; i < nodes.length; i++) {
                if (isHidden(nodes[i]) || isIgnoredInput(nodes[i])) continue;
                if (seen.indexOf(nodes[i]) !== -1) continue;
                seen.push(nodes[i]);
            }
        }
        seen.sort(function(a, b) {
            var pos = a.compareDocumentPosition(b);
            if (pos & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
            if (pos & Node.DOCUMENT_POSITION_PRECEDING) return 1;
            return 0;
        });
        return seen;
    }

    function collectPreviewBoxes(hosts) {
        var boxes = [];
        var i;
        var j;
        for (i = 0; i < hosts.length; i++) {
            var inner = hosts[i].querySelectorAll(".js-custom-preview-box");
            if (inner.length) {
                for (j = 0; j < inner.length; j++) {
                    if (boxes.indexOf(inner[j]) === -1) boxes.push(inner[j]);
                }
            } else {
                var box = getPreviewBoxForHost(hosts[i]);
                if (box && boxes.indexOf(box) === -1) boxes.push(box);
            }
        }
        if (hosts.length) {
            var sib = hosts[hosts.length - 1].nextElementSibling;
            while (sib && sib.classList && sib.classList.contains("js-custom-preview-box")) {
                if (boxes.indexOf(sib) === -1) boxes.push(sib);
                sib = sib.nextElementSibling;
            }
        }
        return boxes;
    }

    function ensurePreviewBoxCount(boxes, count) {
        if (!count) return boxes;
        var last = boxes[boxes.length - 1];
        if (!last) return boxes;
        while (boxes.length < count) {
            var extra = document.createElement("div");
            extra.className = "js-custom-preview-box is-empty";
            extra.setAttribute("data-kp-extra", "true");
            last.parentNode.insertBefore(extra, last.nextSibling);
            boxes.push(extra);
            last = extra;
        }
        return boxes;
    }

    function fillPreviewBox(previewBox, text, fontFamily, color) {
        if (!previewBox) return;
        previewBox.textContent = text || "";
        var isEmpty = !(text && text.trim());
        previewBox.classList.toggle("is-empty", isEmpty);
        if (fontFamily) applyPreviewFont(previewBox, fontFamily);
        if (color) previewBox.style.color = color;
    }

    function parseFontFamily(value) {
        if (!value) return "";
        var first = value.split(",")[0].trim();
        return first.replace(/^["']+|["']+$/g, "").trim();
    }

    function previewFontAlias(name) {
        return name + " KPFull";
    }

    function googleFontCssUrl(name) {
        return "https://fonts.googleapis.com/css2?family=" + encodeURIComponent(name).replace(/%20/g, "+") + "&display=swap";
    }

    function ensureGoogleFont(family) {
        var name = parseFontFamily(family);
        if (!name || name === "sans-serif" || name === "serif" || name === "system-ui" || name === "none") return;
        if (loadedFontFamilies[name]) return;
        loadedFontFamilies[name] = "loading";

        var url = googleFontCssUrl(name);
        var alias = previewFontAlias(name);

        function injectLink() {
            var link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = url;
            document.head.appendChild(link);
            loadedFontFamilies[name] = "link";
        }

        if (!window.fetch) {
            injectLink();
            return;
        }

        fetch(url)
            .then(function(res) { return res.text(); })
            .then(function(css) {
                if (!css || css.indexOf("@font-face") === -1) {
                    injectLink();
                    return;
                }
                var style = document.createElement("style");
                style.setAttribute("data-preview-font", name);
                style.textContent = css + "\n" + css.replace(/font-family:\s*['"]?[^;{}]+['"]?/gi, "font-family:'" + alias + "'");
                document.head.appendChild(style);
                loadedFontFamilies[name] = "full";
                updatePreview();
            })
            .catch(injectLink);
    }

    function fontFromElement(el) {
        if (!el) return "";
        var fontSpan = el.classList && el.classList.contains("key_font_name") ? el : (el.querySelector && el.querySelector(".key_font_name"));
        var source = fontSpan || el;
        if (source.style && source.style.fontFamily) return source.style.fontFamily;
        if (fontSpan && fontSpan.textContent) return '"' + fontSpan.textContent.trim() + '"';
        var ariaLabel = el.getAttribute && el.getAttribute("aria-label");
        if (ariaLabel) return '"' + ariaLabel + '"';
        return "";
    }

    function fontFromDropdown(previewEl, startEl) {
        var combo = lastInRange(
            startEl,
            previewEl,
            ".key_font_dropdown_selected .key_combobox_input, .key_option_fpd .key_combobox_input, [data-option-type='fontpickerdropdown'] .key_combobox_input"
        );
        if (combo) {
            if (combo.style && combo.style.fontFamily) return combo.style.fontFamily;
            var typed = (combo.value || "").trim();
            if (typed && typed.toLowerCase() !== "pick a font") return '"' + typed + '"';
        }

        var option = lastInRange(
            startEl,
            previewEl,
            ".key_font_dropdown_option[aria-selected='true'] .key_font_dropdown_option_text, .key_font_dropdown_option_selected:not(.key_font_dropdown_option_placeholder) .key_font_dropdown_option_text"
        );
        if (option) {
            if (option.style && option.style.fontFamily) return option.style.fontFamily;
            var label = (option.textContent || "").trim();
            if (label) return '"' + label + '"';
        }

        return "";
    }

    function getSelectedFontFamily(previewEl, startEl) {
        var fromDropdown = fontFromDropdown(previewEl, startEl);
        if (fromDropdown) return fromDropdown;

        var radio = lastInRange(
            startEl,
            previewEl,
            "[data-option-type='fontpicker'] input[type='radio']:checked, .key_option_fp input[type='radio']:checked"
        );
        if (radio) {
            var group = radio.closest(".key_option_value") || radio.parentElement;
            var button = group && group.querySelector(".key_font_button");
            var fromRadio = fontFromElement(button);
            if (fromRadio) return fromRadio;
        }

        var selected = lastInRange(
            startEl,
            previewEl,
            ".key_font_button[aria-pressed='true'], .key_font_button.key_button_selected"
        );
        if (selected) {
            selected = selected.closest(".key_font_button") || selected;
            var fromButton = fontFromElement(selected);
            if (fromButton) return fromButton;
        }

        return "";
    }

    function applyPreviewFont(previewBox, family) {
        var name = parseFontFamily(family);
        if (!name) return;
        ensureGoogleFont(family);
        var stack = '"' + previewFontAlias(name) + '", ' + family + ", sans-serif";
        previewBox.style.setProperty("font-family", stack, "important");
    }

    function colorFromSwatch(visual) {
        if (!visual) return "";
        var fill = visual.querySelector(".key_swatch_color, .key_swatch_color_segment");
        if (fill) {
            if (fill.style.backgroundColor) return fill.style.backgroundColor;
            var computed = window.getComputedStyle(fill).backgroundColor;
            if (computed && computed !== "rgba(0, 0, 0, 0)" && computed !== "transparent") return computed;
        }
        var item = visual.closest(".key_swatch_item") || visual;
        var title = item.querySelector(".key_swatch_title, .key_swatch_text");
        var label = (title && title.textContent) || item.getAttribute("aria-label") || visual.getAttribute("data-swatch-tooltip") || "";
        return label;
    }

    function getSelectedColor(previewEl, startEl) {
        var visual = lastInRange(startEl, previewEl, ".key_swatch_visual.key_swatch_selected, .key_option_sw .key_swatch_selected");
        var fromSwatch = colorFromSwatch(visual);
        if (fromSwatch && fromSwatch.charAt(0) !== "#" && fromSwatch.indexOf("rgb") !== 0 && fromSwatch.indexOf("hsl") !== 0) {
            var named = {
                white: "#ffffff",
                black: "#111111",
                red: "#c41e3a",
                lime: "#32cd32",
                gold: "#d4af37",
                silver: "#c0c0c0",
                pink: "#ff69b4",
                blue: "#1e90ff",
                green: "#228b22",
                yellow: "#ffd700",
                orange: "#ff8c00",
                purple: "#800080",
                navy: "#001f3f",
                teal: "#008080"
            };
            var key = fromSwatch.toLowerCase();
            var name;
            for (name in named) {
                if (key.indexOf(name) !== -1) return named[name];
            }
            return "";
        }
        if (fromSwatch) return fromSwatch;

        var hexInput = lastInRange(startEl, previewEl, ".key_color_text");
        if (hexInput && hexInput.value) return hexInput.value;
        return "";
    }

    function hidePreviewTitles() {
        var titles = document.querySelectorAll(".key_option_title");
        var i;
        for (i = 0; i < titles.length; i++) {
            var text = titles[i].textContent.replace(/\s+/g, " ").trim();
            if (isPreviewTitle(titles[i]) || text === "Info:") titles[i].style.display = "none";
        }
    }

    function updatePreview() {
        hidePreviewTitles();

        var fontButtons = document.querySelectorAll(".key_font_name, .key_font_dropdown_option_text");
        var i;
        for (i = 0; i < fontButtons.length; i++) {
            if (!isHidden(fontButtons[i])) {
                ensureGoogleFont(fontButtons[i].style.fontFamily || fontButtons[i].textContent);
            }
        }

        var inputs = getAllTextInputs();
        var hosts = findAllPreviewHosts();
        var boxes = collectPreviewBoxes(hosts);
        boxes = ensurePreviewBoxCount(boxes, inputs.length);

        var fontFamily = getSelectedFontFamily(null, null);
        var color = getSelectedColor(null, null);

        for (i = 0; i < boxes.length; i++) {
            var text = inputs[i] ? (inputs[i].value || "") : "";
            fillPreviewBox(boxes[i], text, fontFamily, color);
        }

        for (i = 0; i < hosts.length; i++) {
            var hostBoxes = hosts[i].querySelectorAll(".js-custom-preview-box");
            var anyText = false;
            var b;
            for (b = 0; b < hostBoxes.length; b++) {
                if (hostBoxes[b].textContent && hostBoxes[b].textContent.trim()) anyText = true;
            }
            var sib = hosts[i].nextElementSibling;
            while (sib && sib.classList && sib.classList.contains("js-custom-preview-box")) {
                if (sib.textContent && sib.textContent.trim()) anyText = true;
                sib = sib.nextElementSibling;
            }
            hosts[i].classList.toggle("is-empty", !anyText);
        }
    }

    function start() {
        if (window.__keystoneCustomPreviewStarted) return;
        window.__keystoneCustomPreviewStarted = true;
        document.body.addEventListener("input", updatePreview, true);
        document.body.addEventListener("change", updatePreview, true);
        document.body.addEventListener("keyup", updatePreview, true);
        document.body.addEventListener("click", function() {
            window.setTimeout(updatePreview, 0);
            window.setTimeout(updatePreview, 150);
        }, true);
        setInterval(updatePreview, 300);
        updatePreview();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", start);
    } else {
        start();
    }
})();
